import React from 'react';

export default function Spacer({ height, clasName }) {
  return <div className={clasName} style={{ height }}></div>;
}
